import { Link, useLoaderData, useParams } from "react-router-dom";
import { Profile } from "../../../services/profile/profileModel";
import SuspenseVideoPlayer from "../../../components/SuspenseVideoPlayer";
import { ReturnButton } from "../../../components/ReturnButton";
import { useTranslation } from "react-i18next";
import SharedInvitationDialog from "./SharedInvitationDialog";
import { authService } from "../../../services/auth/authService";
import { useState } from "react";
import SharedCreateAccountDialog from "./SharedCreateAccountDialog";

const { isLoggedIn: getIsLoggedIn } = authService();

const SharedPage = () => {
  const { t } = useTranslation();
  const { uid } = useParams();
  const { profile, video } = useLoaderData() as {
    profile: Profile;
    video: Promise<Blob> | null;
  };

  const isLoggedIn = getIsLoggedIn();

  const [showCreateAccountCta, setShowCreateAccountCta] = useState(false);

  return (
    <div className="layout_content --bg--organization">
      <div className="page-content container --wrap--m ">
        {isLoggedIn && (
          <div>
            <ReturnButton forcedUrl="/organization/candidates">
              {t("organization:shared-profile.RETURN_TO_PROFILES")}
            </ReturnButton>
          </div>
        )}
        <div className="page_head lblock">
          <h1 className="page_title">
            {t("organization:shared-profile.PROFILE_OF", {
              name: profile.user!.firstname + " " + profile.user?.lastname,
            })}
          </h1>
          <Link
            className="link --danger --underlined"
            to={`${isLoggedIn ? "/organization/contact" : "/contact"}?object=${encodeURIComponent(
              t("organization:shared-profile.REPORT_PROFILE_OBJECT", {
                profileId: profile.id,
                name: profile.user?.firstname + " " + profile.user?.lastname,
                userId: profile.user?.id,
              }),
            )}&message=${encodeURIComponent(t("organization:shared-profile.REASON"))}`}
          >
            {t("organization:shared-profile.REPORT_PROFILE")}
          </Link>
        </div>
        <div className="lrow --gap--l lblock--l">
          <div
            className="--stretch"
            style={{
              overflow: "hidden",
            }}
          >
            <div
              className={"video-container --placeholder"}
              style={
                !video
                  ? {
                      backgroundImage: `url("${profile.thumbnail}")`,
                      backgroundPosition: "center",
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      filter: "blur(15px)",
                    }
                  : {}
              }
            >
              {video && (
                <SuspenseVideoPlayer
                  videoPromise={video}
                  thumbnail={profile.thumbnail}
                  onPause={() => {
                    if (!isLoggedIn) setShowCreateAccountCta(true);
                  }}
                  onEnded={() => {
                    if (!isLoggedIn) setShowCreateAccountCta(true);
                  }}
                />
              )}
            </div>
          </div>
        </div>
        {/* Bloc CTA "Attirer plus de candidats ?" désactivé : le lien vers
            /organization/capsules était jugé déceptif et peu clair.
            À réactiver (ou remplacer) quand une meilleure formulation sera trouvée.
        {isLoggedIn && (
          <div className="cblock card --outlined-on-bg">
            <div className="card_body">
              <div className="--txt--center">
                {t("organization:shared-profile.2MM_DESCRIPTION")}
              </div>
              <div className="lblock --txt--center">
                <Link
                  className="btn--white"
                  to="/organization/capsules"
                  dangerouslySetInnerHTML={{
                    __html: t("organization:shared-profile.CONNECTED_CTA"),
                  }}
                />
              </div>
            </div>
          </div>
        )}
        */}
      </div>
      {!video && !isLoggedIn && (
        <SharedInvitationDialog uid={uid!} profile={profile} />
      )}
      {showCreateAccountCta && (
        <SharedCreateAccountDialog
          uid={uid!}
          onClose={() => setShowCreateAccountCta(false)}
        />
      )}
    </div>
  );
};

export default SharedPage;
